// extracted by mini-css-extract-plugin
export default {"blogCard":"Blog_blogCard__-eu0v","extLinkIcon":"Blog_extLinkIcon__ZGLW2","blogExtLink":"Blog_blogExtLink__VSC6Y"};